<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="id"
        v-slot="{ validated, valid, errors }"
        slim
    >
        <rkm-form-group
            :invalid-feedback="errors[0]"
            :label-for="id"
            :description="description"
            :label="label && label + (validations && validations.required ? ' *' : '')"
            :state="rules ? (disabled ? null : (validated ? valid : null)) : null"
        >

            <VueEditor
                ref="editor"
                :editor-toolbar="editorToolbar"
                :disabled="disabled"
                :placeholder="placeholder"
                :value="value"
                @input="$emit('input', $event)"
                @ready="onEditorReady"
            />

            <div
                v-if="(rules && (rules.max_without_html || rules.max))"
                :style="caracteresRestantesStyle"
            >
                Caracteres restantes: {{ caracteresRestantes }}
            </div>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import { VueEditor } from "vue2-editor"
import { ValidationProvider } from 'vee-validate';

export default {
    components: { VueEditor, ValidationProvider },
    computed: {
        id() {

            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
        rules() {

            return this.disabled ? null : this.validations
        },
        caracteresRestantes() {

            if (!this.editorQuill) return this.rules?.max_without_html || this.rules?.max || 0

            const max = this.rules?.max_without_html || this.rules?.max || 0
            const length = this.editorQuill.getLength() - 1
            const restante = max - length
            return restante > 0 ? restante : 0
        },
        caracteresRestantesStyle() {

            return {
                fontSize: '13px',
                color: 'gray',
            }
        }
    },
    data() {
        return {
            editorQuill: null,
            editorToolbar: [
                [
                    { header: [false, 1, 2, 3, 4, 5, 6] }
                ],
                ["bold", "italic", "underline", "strike"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [
                    { list: "ordered" },
                    { list: "bullet" },
                    { list: "check" }
                ],
                [
                    { color: [] },
                    { background: [] }
                ],
            ],
        }
    },
    methods: {
        onEditorReady(quill) {
            this.editorQuill = quill
        }
    },
    props: {
        disabled: { type: Boolean },
        label: { type: String },
        placeholder: { type: String },
        value: { type: [Number, String], default: '' },
        description: { type: String },
        validationMode: { type: String, default: 'aggressive' },
        name: { type: String },
        required: { type: Boolean, default: false },
        validations: { type: Object, default: null },
    },
    mounted() {
        this.$nextTick(() => {
            const quill = this.$refs.editor.quill
            this.$emit('ready', quill)
        })
    }
}
</script>

<style scoped>
::v-deep(.ql-editor) {
  white-space: pre-wrap !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}
</style>